import type { FC } from "react";
import { useTranslation } from "react-i18next";
import MetaChip from "../../../UIToolkit/Badges/MetaChip";

/** Marks a text that went out as part of a facility announcement, wherever it shows in a person's chat. */
export const FacilityMessageTag: FC<{ dataTestId: string }> = ({ dataTestId }) => {
	const { t } = useTranslation();
	return (
		<MetaChip
			label={t("chat.message.facility.tag")}
			tone="primary"
			sx={{ textTransform: "uppercase", letterSpacing: "0.04em", flexShrink: 0, alignSelf: "flex-start" }}
			dataTestId={dataTestId}
		/>
	);
};
